import type { XY } from "../xy";
import { Effect } from "./effect";

export type EffectTravel = { destination: XY; time: number };

export abstract class XYEffect extends Effect {
	xy: XY;
	private travel: EffectTravel | null = null;

	constructor(xy: XY) {
		super();
		this.xy = xy;
	}

	setTravel(destination: XY, time: number): void {
		this.travel = { destination, time };
	}

	getTravel(): EffectTravel | null {
		return this.travel;
	}
}
